// Cohorts listing data - currently empty, coming soon
export const cohorts = [];
